var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-container',[_c('h1',[_vm._v("Server Error")]),_c('p',[_vm._v("An unexpected error has occurred")])])
}
var staticRenderFns = []

export { render, staticRenderFns }